import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ViewMode } from "src/app/shared/enums/view-mode.enum";
import { PermissionAppointments } from "../shared/models/appointment.permission.model";
import { SinglePermissionModel } from "../shared/models/IPermission";
import { PermissionsServiceService } from "../shared/services/permissions-service.service";
import { TranslationLoaderFacade } from "../../localization/translation-loader.facade";
import {
  getViewModleForPermissions,
  setSelectAllAppointmentStatus,
} from "./permissions-appointment.mapper";

@Component({
  selector: "app-permissions-appointment-concierge",
  templateUrl: "./permissions-appointment-concierge.component.html",
  styleUrls: ["./permissions-appointment-concierge.component.scss"],
})
export class PermissionsAppointmentConciergeComponent
  implements OnInit, OnDestroy
{
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  private _allPermissionInCategory: { data: any[]; groupPermission: number[] } =
    { data: [], groupPermission: [] };
  @Input() set allPermissionsInCategory(value: {
    data: any[];
    groupPermission: number[];
  }) {
    this._allPermissionInCategory = value;
    this.updatModlesFromBackEnd(this._allPermissionInCategory?.data ?? []);
  }

  isLoaded: boolean = false;

  @Output() AppointementsObject: EventEmitter<PermissionAppointments> =
    new EventEmitter<PermissionAppointments>();

  public permissionAppointments: PermissionAppointments =
    new PermissionAppointments();
  public initialPermissionAppointmentsState: PermissionAppointments =
    new PermissionAppointments();
  @Input() isViewOnly: boolean = false;
  @Input() isUkgDefaultGroup: boolean = false;
  @Output() sectionSelectAll = new EventEmitter<boolean>(false);
  public disabledSelectAllAppointments: boolean = true;
  constructor(
    public permissionService: PermissionsServiceService,
    private translationLoaderFacade: TranslationLoaderFacade
  ) {}

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.permissionAppointments = new PermissionAppointments();
  }

  private updatModlesFromBackEnd(modle: SinglePermissionModel[]) {
    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((isEditting) => {
        if (isEditting) {
          this.setedditingParams(modle, isEditting.viewMode);
        } else {
          this.setAddParams(modle);
        }
        this.initialPermissionAppointmentsState = JSON.parse(
          JSON.stringify(this.permissionAppointments)
        );
      });
  }

  checkSelectAllPermission(isSelectAllEnabled: boolean) {
    if (isSelectAllEnabled) {
      this.initSelectAllAppointment();
    } else {
      this.permissionAppointments.selectAllPermissionAppointments.Selected =
        false;
      this.sectionSelectAll.emit(false);
    }
  }

  onReportItemChange(emitDirty: boolean = true) {
    this.permissionAppointments.Reports.selectAll =
      this.permissionAppointments.Reports.viewAppointmentDetailsReport
        .Selected &&
      this.permissionAppointments.Reports.viewCampaignSummaryReport.Selected &&
      this.permissionAppointments.Reports.viewAppointmentTrendsReport.Selected;
    this.initSelectAllAppointment();
    this.publishUpdatedObject(emitDirty);
  }

  selectAllReports() {
    this.permissionAppointments.Reports.viewAppointmentDetailsReport.Selected =
      this.permissionAppointments.Reports.viewAppointmentDetailsReport
        .Selected &&
      !this.permissionAppointments.Reports.viewAppointmentDetailsReport.Enabled
        ? true
        : this.permissionAppointments.Reports.selectAll &&
          this.permissionAppointments.Reports.viewAppointmentDetailsReport
            .Enabled;
    this.permissionAppointments.Reports.viewCampaignSummaryReport.Selected =
      this.permissionAppointments.Reports.viewCampaignSummaryReport.Selected &&
      !this.permissionAppointments.Reports.viewCampaignSummaryReport.Enabled
        ? true
        : this.permissionAppointments.Reports.selectAll &&
          this.permissionAppointments.Reports.viewCampaignSummaryReport.Enabled;
    this.permissionAppointments.Reports.viewAppointmentTrendsReport.Selected =
      this.permissionAppointments.Reports.viewAppointmentTrendsReport
        .Selected &&
      !this.permissionAppointments.Reports.viewAppointmentTrendsReport.Enabled
        ? true
        : this.permissionAppointments.Reports.selectAll &&
          this.permissionAppointments.Reports.viewAppointmentTrendsReport
            .Enabled;
    this.checkSelectAllPermission(
      this.permissionAppointments.Reports.selectAll
    );
    this.publishUpdatedObject();
  }

  onSystemSettingsItemChange(emitDirty: boolean = true) {
    this.permissionAppointments.SystemSettings.selectAll =
      this.permissionAppointments.SystemSettings.viewSystemSettings.Selected &&
      this.permissionAppointments.SystemSettings.viewSystemSettings.Enabled;
    this.initSelectAllAppointment();
    this.publishUpdatedObject(emitDirty);
  }

  selectAllSystemSettings() {
    if (this.permissionAppointments.SystemSettings.selectAll == true) {
      this.permissionAppointments.SystemSettings.viewSystemSettings.Selected =
        true;
      this.permissionAppointments.SystemSettings.viewSystemSettings.Enabled =
        true;
      this.initSelectAllAppointment();
    } else {
      this.permissionAppointments.SystemSettings.viewSystemSettings.Selected =
        false;
      this.permissionAppointments.SystemSettings.viewSystemSettings.Enabled =
        false;
      this.permissionAppointments.selectAllPermissionAppointments.Selected =
        false;
      this.sectionSelectAll.emit(false);
    }
    this.publishUpdatedObject();
  }

  onActionCenterItemChange(emitDirty: boolean = true) {
    this.permissionAppointments.ViewActionCenter.selectAll =
      this.permissionAppointments.ViewActionCenter.viewActionCenter.Selected &&
      this.permissionAppointments.ViewActionCenter.editActionCenter.Selected &&
      this.permissionAppointments.ViewActionCenter.changeAppointmentAssignment
        .Selected &&
      this.permissionAppointments.ViewActionCenter.sendFollowUpEnable
        .Selected &&
      this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments
        .Selected &&
      this.permissionAppointments.ViewActionCenter.changeAppointmentStatus
        .Selected;

    this.validate();
    this.initSelectAllAppointment();
    this.uncheckEditActionCenterPermissions(
      this.permissionAppointments.ViewActionCenter.editActionCenter.Selected
    );
    this.handleActionCenterIChildElements();
    this.publishUpdatedObject(emitDirty);
  }
  handleActionCenterIChildElements() {
    const actionCenter = this.permissionAppointments.ViewActionCenter;
    if (!actionCenter.viewActionCenter.Selected) {
      actionCenter.editActionCenter.Selected = false;
      actionCenter.changeAppointmentAssignment.Selected = false;
      actionCenter.sendFollowUpEnable.Selected = false;
      actionCenter.bulkDeleteAppointments.Selected = false;
      actionCenter.changeAppointmentStatus.Selected = false;
    }
  }
  selectAllActionCenter() {
    this.permissionAppointments.ViewActionCenter.viewActionCenter.Selected =
      this.permissionAppointments.ViewActionCenter.viewActionCenter.Selected &&
      !this.permissionAppointments.ViewActionCenter.viewActionCenter.Enabled
        ? true
        : this.permissionAppointments.ViewActionCenter.selectAll &&
          this.permissionAppointments.ViewActionCenter.viewActionCenter.Enabled;
    this.permissionAppointments.ViewActionCenter.editActionCenter.Selected =
      this.permissionAppointments.ViewActionCenter.editActionCenter.Selected &&
      !this.permissionAppointments.ViewActionCenter.editActionCenter.Enabled
        ? true
        : this.permissionAppointments.ViewActionCenter.selectAll &&
          this.permissionAppointments.ViewActionCenter.editActionCenter.Enabled;
    this.permissionAppointments.ViewActionCenter.changeAppointmentAssignment.Selected =
      this.permissionAppointments.ViewActionCenter.changeAppointmentAssignment
        .Selected &&
      !this.permissionAppointments.ViewActionCenter.changeAppointmentAssignment
        .Enabled
        ? true
        : this.permissionAppointments.ViewActionCenter.selectAll &&
          this.permissionAppointments.ViewActionCenter
            .changeAppointmentAssignment.Enabled;
    this.permissionAppointments.ViewActionCenter.sendFollowUpEnable.Selected =
      this.permissionAppointments.ViewActionCenter.sendFollowUpEnable
        .Selected &&
      !this.permissionAppointments.ViewActionCenter.sendFollowUpEnable.Enabled
        ? true
        : this.permissionAppointments.ViewActionCenter.selectAll &&
          this.permissionAppointments.ViewActionCenter.sendFollowUpEnable
            .Enabled;
    this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments.Selected =
      this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments
        .Selected &&
      !this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments
        .Enabled
        ? true
        : this.permissionAppointments.ViewActionCenter.selectAll &&
          this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments
            .Enabled;
    this.permissionAppointments.ViewActionCenter.changeAppointmentStatus.Selected =
      this.permissionAppointments.ViewActionCenter.changeAppointmentStatus
        .Selected &&
      !this.permissionAppointments.ViewActionCenter.changeAppointmentStatus
        .Enabled
        ? true
        : this.permissionAppointments.ViewActionCenter.selectAll &&
          this.permissionAppointments.ViewActionCenter.changeAppointmentStatus
            .Enabled;
    this.checkSelectAllPermission(
      this.permissionAppointments.ViewActionCenter.selectAll
    );
    this.validate();
    this.publishUpdatedObject();
  }

  onAppointmentsItemChange(emitDirty: boolean = true) {
    this.permissionAppointments.Appointements.selectAll =
      this.permissionAppointments.Appointements.appointmentsEdit.Selected &&
      this.permissionAppointments.Appointements.appointmentsView.Selected &&
      this.permissionAppointments.Appointements.appointmentsDelete.Selected &&
      this.permissionAppointments.Appointements.ExceptionsEdit.Selected &&
      this.permissionAppointments.Appointements.ExceptionsDelete.Selected &&
      this.permissionAppointments.Appointements.appointmentsAdd.Selected;
    this.initSelectAllAppointment();
    this.handleAppointmentsChildElements();
    this.publishUpdatedObject(emitDirty);
  }
  handleAppointmentsChildElements() {
    const appointMent = this.permissionAppointments.Appointements;
    if (!appointMent.appointmentsView.Selected) {
      appointMent.appointmentsEdit.Selected = false;
      appointMent.appointmentsAdd.Selected = false;
      appointMent.appointmentsDelete.Selected = false;
      appointMent.ExceptionsAdd.Selected = false;
      appointMent.ExceptionsEdit.Selected = false;
      appointMent.ExceptionsDelete.Selected = false;
      appointMent.appointmentsAdd.Selected = false;
    }
  }
  selectAllGeneral() {
    this.permissionAppointments.Appointements.appointmentsEdit.Selected =
      this.permissionAppointments.Appointements.appointmentsEdit.Selected &&
      !this.permissionAppointments.Appointements.appointmentsEdit.Enabled
        ? true
        : this.permissionAppointments.Appointements.selectAll &&
          this.permissionAppointments.Appointements.appointmentsEdit.Enabled;
    this.permissionAppointments.Appointements.appointmentsView.Selected =
      this.permissionAppointments.Appointements.appointmentsView.Selected &&
      !this.permissionAppointments.Appointements.appointmentsView.Enabled
        ? true
        : this.permissionAppointments.Appointements.selectAll &&
          this.permissionAppointments.Appointements.appointmentsView.Enabled;
    this.permissionAppointments.Appointements.appointmentsDelete.Selected =
      this.permissionAppointments.Appointements.appointmentsDelete.Selected &&
      !this.permissionAppointments.Appointements.appointmentsDelete.Enabled
        ? true
        : this.permissionAppointments.Appointements.selectAll &&
          this.permissionAppointments.Appointements.appointmentsDelete.Enabled;
    this.permissionAppointments.Appointements.appointmentsAdd.Selected =
      this.permissionAppointments.Appointements.appointmentsAdd.Selected &&
      !this.permissionAppointments.Appointements.appointmentsAdd.Enabled
        ? true
        : this.permissionAppointments.Appointements.selectAll &&
          this.permissionAppointments.Appointements.appointmentsAdd.Enabled;
    this.permissionAppointments.Appointements.ExceptionsAdd.Selected =
      this.permissionAppointments.Appointements.ExceptionsAdd.Selected &&
      !this.permissionAppointments.Appointements.ExceptionsAdd.Enabled
        ? true
        : this.permissionAppointments.Appointements.selectAll &&
          this.permissionAppointments.Appointements.ExceptionsAdd.Enabled;
    this.permissionAppointments.Appointements.ExceptionsEdit.Selected =
      this.permissionAppointments.Appointements.ExceptionsEdit.Selected &&
      !this.permissionAppointments.Appointements.ExceptionsEdit.Enabled
        ? true
        : this.permissionAppointments.Appointements.selectAll &&
          this.permissionAppointments.Appointements.ExceptionsEdit.Enabled;
    this.permissionAppointments.Appointements.ExceptionsDelete.Selected =
      this.permissionAppointments.Appointements.ExceptionsDelete.Selected &&
      !this.permissionAppointments.Appointements.ExceptionsDelete.Enabled
        ? true
        : this.permissionAppointments.Appointements.selectAll &&
          this.permissionAppointments.Appointements.ExceptionsDelete.Enabled;
    this.checkSelectAllPermission(
      this.permissionAppointments.Appointements.selectAll
    );
    this.publishUpdatedObject();
  }

  public publishUpdatedObject(emitDirty: boolean = true) {
    if (
      emitDirty &&
      JSON.stringify(this.permissionAppointments) !==
        JSON.stringify(this.initialPermissionAppointmentsState)
    ) {
      this.dirtyEmitter.emit(true);
    } else {
      this.dirtyEmitter.emit(false);
    }
    this.AppointementsObject.emit(this.permissionAppointments);
  }

  setedditingParams(model: SinglePermissionModel[], viewMode: number) {
    this.permissionAppointments = getViewModleForPermissions(
      model,
      viewMode,
      this._allPermissionInCategory.groupPermission
    );
    this.disabledSelectAllAppointments = setSelectAllAppointmentStatus(
      this.permissionAppointments
    );
    //this.permissionAppointments = getViewModleForPermissions(model, true, viewMode);
    this.initSelectAll();
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  setAddParams(model: SinglePermissionModel[]) {
    this.permissionAppointments = getViewModleForPermissions(
      model,
      ViewMode.Add
    );
    this.disabledSelectAllAppointments = setSelectAllAppointmentStatus(
      this.permissionAppointments
    );
    //this.permissionAppointments = getViewModleForPermissions(model, false);
    this.initSelectAll();
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  private initSelectAll() {
    this.onAdminSettingsChanged(false);
    this.onCampaignsSettingsChanged(false);
    this.onEventsSettingsChanged(false);

    this.onActionCenterItemChange(false);
    this.onReportItemChange(false);
    this.onSystemSettingsItemChange(false);
    this.onAppointmentsItemChange(false);

    this.initSelectAllAppointment();
  }

  public onAdminSettingsChanged(emitDirty: boolean = true) {
    this.permissionAppointments.Administration.selectAll =
      this.permissionAppointments.Administration.ViewEditAdministration
        .Selected &&
      this.permissionAppointments.Administration.ViewEditEventSettings.Selected;
    this.initSelectAllAppointment();
    this.handleAdminSettingsChildElements();
    this.publishUpdatedObject(emitDirty);
  }
  handleAdminSettingsChildElements() {
    const admin = this.permissionAppointments.Administration;
    if (!admin.ViewEditAdministration.Selected) {
      admin.ViewEditEventSettings.Selected = false;
    }
  }
  public onAdminSelectAll() {
    this.permissionAppointments.Administration.ViewEditAdministration.Selected =
      this.permissionAppointments.Administration.ViewEditAdministration
        .Selected &&
      !this.permissionAppointments.Administration.ViewEditAdministration.Enabled
        ? true
        : this.permissionAppointments.Administration.selectAll &&
          this.permissionAppointments.Administration.ViewEditAdministration
            .Enabled;
    this.permissionAppointments.Administration.ViewEditEventSettings.Selected =
      this.permissionAppointments.Administration.ViewEditEventSettings
        .Selected &&
      !this.permissionAppointments.Administration.ViewEditEventSettings.Enabled
        ? true
        : this.permissionAppointments.Administration.selectAll &&
          this.permissionAppointments.Administration.ViewEditEventSettings
            .Enabled;
    this.checkSelectAllPermission(
      this.permissionAppointments.Administration.selectAll
    );
    this.publishUpdatedObject();
  }

  public onCampaignsSettingsChanged(emitDirty: boolean = true) {
    this.permissionAppointments.Campaigns.selectAll =
      this.permissionAppointments.Campaigns.ViewCampaigns.Selected &&
      this.permissionAppointments.Campaigns.EditCampaigns.Selected;
    this.initSelectAllAppointment();
    this.handleCampaignsSettingsChildElements();
    this.publishUpdatedObject(emitDirty);
  }
  handleCampaignsSettingsChildElements() {
    const campaigns = this.permissionAppointments.Campaigns;
    if (!campaigns.ViewCampaigns.Selected) {
      campaigns.EditCampaigns.Selected = false;
    }
  }
  public onCampaignsSelectAll() {
    this.permissionAppointments.Campaigns.ViewCampaigns.Selected =
      this.permissionAppointments.Campaigns.ViewCampaigns.Selected &&
      !this.permissionAppointments.Campaigns.ViewCampaigns.Enabled
        ? true
        : this.permissionAppointments.Campaigns.selectAll &&
          this.permissionAppointments.Campaigns.ViewCampaigns.Enabled;
    this.permissionAppointments.Campaigns.EditCampaigns.Selected =
      this.permissionAppointments.Campaigns.EditCampaigns.Selected &&
      !this.permissionAppointments.Campaigns.EditCampaigns.Enabled
        ? true
        : this.permissionAppointments.Campaigns.selectAll &&
          this.permissionAppointments.Campaigns.EditCampaigns.Enabled;
    this.checkSelectAllPermission(
      this.permissionAppointments.Campaigns.selectAll
    );
    this.publishUpdatedObject();
  }

  public onEventsSettingsChanged(emitDirty: boolean = true) {
    this.permissionAppointments.Events.selectAll =
      this.permissionAppointments.Events.ViewEvents.Selected &&
      this.permissionAppointments.Events.AddEvents.Selected &&
      this.permissionAppointments.Events.EditEvents.Selected &&
      this.permissionAppointments.Events.ActivateDeactivateEvents.Selected;
    this.initSelectAllAppointment();
    this.handleEventsSettingsChildElements();
    this.publishUpdatedObject(emitDirty);
  }
  handleEventsSettingsChildElements() {
    const event = this.permissionAppointments.Events;
    if (!event.ViewEvents.Selected) {
      event.AddEvents.Selected = false;
      event.EditEvents.Selected = false;
      event.ActivateDeactivateEvents.Selected = false;
    }
  }
  public onEventsSelectAll() {
    this.permissionAppointments.Events.ViewEvents.Selected =
      this.permissionAppointments.Events.ViewEvents.Selected &&
      !this.permissionAppointments.Events.ViewEvents.Enabled
        ? true
        : this.permissionAppointments.Events.selectAll &&
          this.permissionAppointments.Events.ViewEvents.Enabled;
    this.permissionAppointments.Events.AddEvents.Selected =
      this.permissionAppointments.Events.AddEvents.Selected &&
      !this.permissionAppointments.Events.AddEvents.Enabled
        ? true
        : this.permissionAppointments.Events.selectAll &&
          this.permissionAppointments.Events.AddEvents.Enabled;
    this.permissionAppointments.Events.EditEvents.Selected =
      this.permissionAppointments.Events.EditEvents.Selected &&
      !this.permissionAppointments.Events.EditEvents.Enabled
        ? true
        : this.permissionAppointments.Events.selectAll &&
          this.permissionAppointments.Events.EditEvents.Enabled;
    this.permissionAppointments.Events.ActivateDeactivateEvents.Selected =
      this.permissionAppointments.Events.ActivateDeactivateEvents.Selected &&
      !this.permissionAppointments.Events.ActivateDeactivateEvents.Enabled
        ? true
        : this.permissionAppointments.Events.selectAll &&
          this.permissionAppointments.Events.ActivateDeactivateEvents.Enabled;
    this.checkSelectAllPermission(this.permissionAppointments.Events.selectAll);
    this.publishUpdatedObject();
  }

  private validate() {
    this.permissionAppointments.ViewActionCenter.isInputValid = !(
      this.permissionAppointments.ViewActionCenter.editActionCenter.Selected &&
      !(
        this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments
          .Selected ||
        this.permissionAppointments.ViewActionCenter.changeAppointmentAssignment
          .Selected ||
        this.permissionAppointments.ViewActionCenter.changeAppointmentStatus
          .Selected ||
        this.permissionAppointments.ViewActionCenter.sendFollowUpEnable.Selected
      )
    );
  }

  valueChangeByselectAllPermissionsAppointment(e: Event) {
    const target = e.target as HTMLInputElement;
    this.valueChangeByselectAllPermissionsAppointmentCommon(target.checked);
    this.sectionSelectAll.emit(target.checked);
  }

  valueChangeByselectAllPermissionsAppointmentCommon(isEnable: boolean) {
    if (
      this.permissionAppointments.Administration.ViewEditAdministration
        .Enabled &&
      this.permissionAppointments.Administration.ViewEditEventSettings.Enabled
    )
      this.permissionAppointments.Administration.selectAll = isEnable;

    if (
      this.permissionAppointments.Appointements.ExceptionsAdd.Enabled &&
      this.permissionAppointments.Appointements.ExceptionsDelete.Enabled &&
      this.permissionAppointments.Appointements.ExceptionsEdit.Enabled &&
      this.permissionAppointments.Appointements.appointmentsAdd.Enabled &&
      this.permissionAppointments.Appointements.appointmentsDelete.Enabled &&
      this.permissionAppointments.Appointements.appointmentsEdit.Enabled &&
      this.permissionAppointments.Appointements.appointmentsView.Enabled
    )
      this.permissionAppointments.Appointements.selectAll = isEnable;

    if (
      this.permissionAppointments.Campaigns.EditCampaigns.Enabled &&
      this.permissionAppointments.Campaigns.ViewCampaigns.Enabled
    )
      this.permissionAppointments.Campaigns.selectAll = isEnable;

    if (
      this.permissionAppointments.Events.ActivateDeactivateEvents.Enabled &&
      this.permissionAppointments.Events.AddEvents.Enabled &&
      this.permissionAppointments.Events.EditEvents.Enabled &&
      this.permissionAppointments.Events.ViewEvents.Enabled
    )
      this.permissionAppointments.Events.selectAll = isEnable;

    if (
      this.permissionAppointments.Reports.viewAppointmentDetailsReport
        .Enabled &&
      this.permissionAppointments.Reports.viewAppointmentTrendsReport.Enabled &&
      this.permissionAppointments.Reports.viewCampaignSummaryReport.Enabled
    )
      this.permissionAppointments.Reports.selectAll = isEnable;
    if (
      this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments
        .Enabled &&
      this.permissionAppointments.ViewActionCenter.changeAppointmentAssignment
        .Enabled &&
      this.permissionAppointments.ViewActionCenter.changeAppointmentStatus
        .Enabled &&
      this.permissionAppointments.ViewActionCenter.editActionCenter.Enabled &&
      this.permissionAppointments.ViewActionCenter.sendFollowUpEnable.Enabled &&
      this.permissionAppointments.ViewActionCenter.viewActionCenter.Enabled
    )
      this.permissionAppointments.ViewActionCenter.selectAll = isEnable;

    this.onAdminSelectAll();
    this.selectAllActionCenter();
    this.selectAllGeneral();
    this.selectAllReports();
    this.onEventsSelectAll();
    this.onCampaignsSelectAll();
  }

  initSelectAllAppointment() {
    this.permissionAppointments.selectAllPermissionAppointments.Selected =
      this.permissionAppointments.Administration.selectAll &&
      this.permissionAppointments.Campaigns.selectAll &&
      this.permissionAppointments.Events.selectAll &&
      this.permissionAppointments.Reports.selectAll &&
      this.permissionAppointments.ViewActionCenter.selectAll &&
      this.permissionAppointments.Appointements.selectAll;

    this.sectionSelectAll.emit(
      this.permissionAppointments.selectAllPermissionAppointments.Selected
    );
  }
  uncheckEditActionCenterPermissions(isChecked: boolean) {
    if (!isChecked) {
      this.permissionAppointments.ViewActionCenter.bulkDeleteAppointments.Selected =
        isChecked;
      this.permissionAppointments.ViewActionCenter.changeAppointmentAssignment.Selected =
        isChecked;
      this.permissionAppointments.ViewActionCenter.changeAppointmentStatus.Selected =
        isChecked;
      this.permissionAppointments.ViewActionCenter.sendFollowUpEnable.Selected =
        isChecked;
    }
  }
}
